import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import { api } from '../services/api';
import { Button, Table, Form, FormGroup, Modal, Accordion } from 'react-bootstrap';
import Select from 'react-select';

import MaterialIcon from 'material-icons-react';

import styles from '../styles/Adm.module.scss';
import { toYYYYMMDD, toUTCDDMMYYYY, toDatetime, toUTCDatetime } from "../utils/dateUtils";
import { toast, ToastContainer } from "react-toastify";
import CookiesService from '../services/cookies';
import Carregando from '../components/Carregando';
import CustomPagination from "../components/Utils/CustomPagination";
import { useMisc } from "../contexts/MiscContext";

const Adm = () => {
  const [mainData, setMainData] = useState([]);
  const [showModalEnvio, setShowModalEnvio] = useState(false);
  const [showModalRecebimento, setShowModalRecebimento] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [formObj, setFormObj] = useState({});
  const [formErrs, setFormErrs] = useState({});
  const [activeObj, setActiveObj] = useState({});
  const [optionsObj, setOptionsObj] = useState({ MotivoEnvioLista: [] });
  const [loading, setLoading] = useState(false);
  const [responsavelAprovacaoLista, setResponsavelAprovacaoLista] = useState([]);

  const today = toYYYYMMDD(new Date());
  const userLogin = CookiesService.getUserLogin();
  const { setShowLoading } = useMisc();

  const quantityPerPage = 20;

  const handleShowModal = async (el) => {
    try {
      setShowLoading(true);
      setActiveObj(el);
      if (el.ValidaEstilo === 'NAO' && el.NumeroLacreEnvio !== '-') return toast.warn('Processo pendente de aprovação do Estilo');
      else if (el.DataEnvioAprovacao === '-') setShowModalEnvio(true);
      else if (el.ValidaEstilo === 'SIM' && el.ConfirmaEnvioAmostra === 'SIM') setShowModalRecebimento(true);

      const res = await api.get('/MPAdmControle/GetResponsavelAprovacaoLista', { params: { Empresa: el.Empresa } })
      setResponsavelAprovacaoLista(res.data);
    } catch (e) {
      setActiveObj({});
      setShowModalEnvio(false);
      setShowModalRecebimento(false);
      toast.error('Erro ao carregar dados. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const handleCloseModal = () => {
    setShowModalEnvio(false);
    setShowModalRecebimento(false);
    setActiveObj({});
    setFormObj({});
    setFormErrs({});
    setResponsavelAprovacaoLista([]);
  }

  const handleFetchMainData = async () => {
    try {
      setShowLoading(true);
      setLoading(true);
      const res = await api.get('/MPAdmControle/GetMainData');
      setMainData(res.data);
    } catch (e) {
      toast.error('Erro ao carregar o grid. Tente novamente ou entre em contato com o suporte.');
    } finally {
      setLoading(false);
      setShowLoading(false);
    }
  }

  const FilterOptions = [
    { label: 'Pendente CQ', value: 'Pendente CQ' },
    { label: 'Pendente Estilo', value: 'Pendente Estilo' },
    { label: 'Pendente Gestao', value: 'Pendente Gestao' },
    { label: 'Exibir Tudo', value: '' }
  ];

  const handleSearch = async () => {
    try {
      setShowLoading(true);
      setLoading(true);
      const res = await api.get('/MPAdmControle/GetMainData', {
        params: {
          ...filterObj,
          FilterOpt: formObj.filterBy && formObj.filterBy.value ? formObj.filterBy.value : ''
        }
      });
      setMainData(res.data);
    } catch (e) {
      toast.error('Erro ao carregar o grid. Tente novamente ou entre em contato com o suporte.');
    } finally {
      setLoading(false);
      setShowLoading(false);
    }
  }

  const handleFetchOptions = async () => {
    try {
      setShowLoading(true);
      const res = await api.get('/MPAdmControle/GetMotivoEnvioLista');
      setOptionsObj({ MotivoEnvioLista: res.data });
    } catch (e) {
      toast.error('Erro ao carregar a lista de envios. Faça um refresh na página.');
    } finally {
      setShowLoading(false);
    }
  }

  const handleEnvioProcessing = async () => {
    try {
      setShowLoading(true);
      const errs = handleEnvioValidation();
      if (Object.keys(errs).length > 0) return setFormErrs(errs);

      const params = {
        DataRegistroEnvio: toDatetime(new Date()),
        DataEnvio: toUTCDatetime(formObj.DataEnvioAprovacao),
        IDUsuarioEnvio: userLogin,
        IDMotivoEnvio: activeObj.MotivoEnvio.match(/^\d+/),
        IDResponsavelAprovacao: formObj.ResponsavelAprovacao.value,
        Lacre: formObj.LacreEnvio
      }

      const validation = {
        Tabela: activeObj.TABELA,
        Pedido: activeObj.Pedido,
        NomeCliFor: activeObj.NomeCliFor,
        Material: activeObj.Material,
        CorMaterial: activeObj.CorMaterial,
        DataAlteracaoPedido: toUTCDatetime(activeObj.DataAlteracaoPedido),
        IDAreaAprovacao: activeObj.IDAreaAprovacao,
        NFEntrada: activeObj.NFEntrada,
        SerieNF: activeObj.SerieNF,
        QtdeEntrada: activeObj.QtdeEntrada
      }

      await api.post('/MPAdmControle/PostProcessarEnvio', { params, validation });
      handleFetchMainData();
      setFilterObj({});
      handleCloseModal();
      toast.success('Os dados foram atualizados com sucesso!');
    } catch (e) {
      toast.error('Ocorreu um erro ao atualizar os dados, por favor entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const handleEnvioValidation = () => {
    const { MotivoEnvio, DataEnvioAprovacao, LacreEnvio } = formObj;
    const errs = {}
    // if (!formObj.ResponsavelAprovacao) errs.ResponsavelAprovacao = 'Selecione uma opção';
    // if (!MotivoEnvio) errs.MotivoEnvio = 'Selecione uma opção';
    if (!DataEnvioAprovacao || new Date(DataEnvioAprovacao).getTime() <= 0 || new Date(DataEnvioAprovacao) < new Date(today)) errs.DataEnvioAprovacao = 'Insira uma data de envio válida e maior ou igual a hoje';
    if (!LacreEnvio) errs.LacreEnvio = 'Insira um nº de lacre válido';
    return errs;
  }

  const handleRecebimentoProcessing = async () => {
    try {
      setShowLoading(true);
      const errs = handleRecebimentoValidation();
      if (Object.keys(errs).length > 0) return setFormErrs(errs);

      const params = {
        ConfirmaRecAmostra: 1,
        DataRecAmostra: toUTCDatetime(formObj.DataRecebimentoAmostra),
        IDUsuarioRecAmostra: userLogin
        // IDUsuarioRecAmostra: userLogin || 'TESTE.HOMOLOG'
      }

      const validation = {
        Tabela: activeObj.TABELA,
        Pedido: activeObj.Pedido,
        NomeCliFor: activeObj.NomeCliFor,
        Material: activeObj.Material,
        CorMaterial: activeObj.CorMaterial,
        DataAlteracaoPedido: toUTCDatetime(activeObj.DataAlteracaoPedido),
        IDAreaAprovacao: activeObj.IDAreaAprovacao,
        NFEntrada: activeObj.NFEntrada,
        SerieNF: activeObj.SerieNF,
        QtdeEntrada: activeObj.QtdeEntrada
      }

      await api.post('/MPAdmControle/PostProcessarRecebimento', { params, validation });
      handleFetchMainData();
      setFilterObj({});
      handleCloseModal();
      toast.success('Os dados foram atualizados com sucesso!');
    } catch (e) {
      toast.error('Ocorreu um erro ao atualizar os dados, por favor entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const handleRecebimentoValidation = () => {
    const { DataRecebimentoAmostra } = formObj;
    const errs = {}
    if (!DataRecebimentoAmostra || new Date(DataRecebimentoAmostra).getTime() <= 0 || new Date(DataRecebimentoAmostra) < new Date(today)) errs.DataRecebimentoAmostra = 'Insira uma data de envio válida e maior ou igual a hoje';
    // if (!ResponsavelRecebimento) errs.ResponsavelRecebimento = 'Selecione uma opção';
    return errs;
  }

  const handleValueMask = (field, value, filter = false) => {
    if (value && value !== undefined) value = `${value.replace(/[^.0-9]*/g, '')}`;
    if (filter === true) setFilterObj({ ...filterObj, [field]: value });
    else setFormObj({ ...formObj, [field]: value });
  }

  const clearErrs = (str) => {
    setFormErrs({ ...formErrs, [str]: null });
  }

  useEffect(() => {
    handleFetchOptions();
    handleFetchMainData();
  }, []);

  // Definir colunas
  const columns = [
    {
      name: '',
      selector: (row) => `${row.ValidaEstilo}_${row.NumeroLacreEnvio}`, // Chave única para caching
      cell: (row) => {
        const IconCell = React.memo(({ row }) => {
          const icon = row.ValidaEstilo === 'NAO' && row.NumeroLacreEnvio !== '-'
            ? 'hide_source'
            : 'task_alt';
          const color = row.ValidaEstilo === 'NAO' && row.NumeroLacreEnvio !== '-'
            ? '#BB271A'
            : '#0D6EFD';

          return (
            <i
              className={styles.iconCursor}
              onClick={(e) => {
                e.stopPropagation();
                handleShowModal(row);
              }}
            >
              <MaterialIcon
                icon={icon}
                size={25}
                color={color}
              />
            </i>
          );
        });

        return <IconCell row={row} />;
      },
      width: '60px',
      sortable: false,
      ignoreRowClick: true,
    },
    {
      name: 'DATA RECEBIMENTO',
      selector: (row) => row.recebimento,
      cell: (row) => toUTCDDMMYYYY(row.recebimento),
      sortable: true,
    },
    {
      name: 'PEDIDO',
      selector: (row) => row.Pedido,
      sortable: true,
    },
    {
      name: 'NF ENTRADA',
      selector: (row) => row.NFEntrada,
      sortable: true,
    },
    {
      name: 'SERIE NF',
      selector: (row) => row.SerieNF,
      sortable: true,
    },
    {
      name: 'CÓD. FORNECEDOR',
      selector: (row) => row.CodigoFornecedor,
      sortable: true,
    },
    {
      name: 'FORNECEDOR',
      selector: (row) => row.NomeCliFor,
      sortable: true,
    },
    {
      name: 'AREA APROVAÇÃO',
      selector: (row) => row.AREAAPROVACAO,
      sortable: true,
    },
    {
      name: 'MATERIAL',
      selector: (row) => row.Material,
      sortable: true,
    },
    {
      name: 'DESCRIÇÃO MATERIAL',
      selector: (row) => row.DescricaoMaterial,
      sortable: true,
    },
    {
      name: 'DESCRIÇÃO COR',
      selector: (row) => row.DescricaoCor,
      sortable: true,
    },
    {
      name: 'QTDE ENTRADA',
      selector: (row) => row.QtdeEntrada,
      sortable: true,
    },
    {
      name: 'TIPO MATERIAL',
      selector: (row) => row.Tipo,
      sortable: true,
    },
    {
      name: 'REQUERIDO POR',
      selector: (row) => row.RequeridoPor,
      sortable: true,
    },
    {
      name: 'DATA REVISÃO',
      selector: (row) => row.DataRevisao,
      sortable: true,
    },
    {
      name: 'STATUS REVISÃO',
      selector: (row) => row.StatusRevisao,
      sortable: true,
    },
    {
      name: 'ENVIADO APROVAÇÃO',
      selector: (row) => row.EnviadoAprovacao,
      sortable: true,
    },
    {
      name: 'MOTIVO ENVIO',
      selector: (row) => row.MotivoEnvio,
      sortable: true,
    },
    {
      name: 'DATA ENVIO',
      selector: (row) => row.DataEnvioAprovacao,
      sortable: true,
    },
    {
      name: 'NÚMERO LACRE ENVIO',
      selector: (row) => row.NumeroLacreEnvio,
      sortable: true,
    },
    {
      name: 'CONFIRMA RECEBIMENTO',
      selector: (row) => row.ConfirmaRecebimento,
      sortable: true,
    },
    {
      name: 'DATA RECEBIMENTO',
      selector: (row) => row.DataRecebimento,
      sortable: true,
    },
    {
      name: 'RESPONSÁVEL RECEBIMENTO AMOSTRA',
      selector: (row) => row.FuncionarioRecebimentoAmostra,
      sortable: true,
    },
    {
      name: 'VALIDADO ESTILO',
      selector: (row) => row.ValidaEstilo,
      sortable: true,
    },
    {
      name: 'FUNCIONÁRIO VALIDAÇÃO',
      selector: (row) => row.FuncionarioValidacao,
      sortable: true,
    },
    {
      name: 'STATUS ESTILO',
      selector: (row) => row.StatusEstilo,
      sortable: true,
    },
    {
      name: 'CONFIRMA ENVIO AMOSTRA',
      selector: (row) => row.ConfirmaEnvioAmostra,
      sortable: true,
    },
    {
      name: 'CONFIRMA RETORNO AMOSTRA',
      selector: (row) => row.ConfirmaRetornoAmostra,
      sortable: true,
    },
    {
      name: 'NÚMERO LACRE',
      selector: (row) => row.LacreRetornoAmostra,
      sortable: true,
    },
    {
      name: 'STATUS CQ',
      selector: (row) => row.StatusCQ,
      sortable: true,
    },
    {
      name: 'DESTINO ANÁLISE',
      selector: (row) => row.DestinoAnalise,
      sortable: true,
    },
    {
      name: 'DIRECIONAMENTO',
      selector: (row) => row.Direcionamento,
      cell: (row) => row.Direcionamento === '' ? '-' : row.Direcionamento,
      sortable: true,
    },
  ];

  // Definir estilos customizados
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f8f9fa',
        fontWeight: 'bold',
        fontSize: '14px',
        color: '#333',
        padding: '10px 15px',
      },
    },
    cells: {
      style: {
        fontSize: '14px',
        padding: '8px 15px',
        cursor: 'pointer',
      },
    },
    rows: {
      style: {
        borderBottom: '1px solid #dee2e6',
        '&:hover': {
          backgroundColor: 'rgba(0,0,0,0.05)',
        },
      },
      denseStyle: {
        minHeight: '40px',
      },
    },
  }

  return (
    <div>
      <div className="p-3">
        <div>
          <h3>ADM</h3>

          {/* Forms busca */}
          <article>
            <Form className={styles.form}>
              <FormGroup className={styles.formGroup}>
                <Form.Label className={styles.formLabel}>Filtrar por</Form.Label>
                <Select
                  options={FilterOptions}
                  isClearable={true}
                  backspaceRemovesValue={true}
                  // onClick={}
                  onChange={e => setFormObj({ ...filterObj, filterBy: e })}
                />

              </FormGroup>
              <FormGroup className={styles.formGroup}>
                <Form.Label className={styles.formLabel}>NF Entrada</Form.Label>
                <Form.Control
                  type="text"
                  value={filterObj.NFEntrada || ''}
                  onChange={e => handleValueMask('NFEntrada', e.target.value, true)}
                  placeholder={'Número da NF'}
                />
              </FormGroup>
              <FormGroup className={styles.formGroup}>
                <Form.Label className={styles.formLabel}>Material</Form.Label>
                <Form.Control
                  type="text"
                  value={filterObj.Material || ''}
                  onChange={e => handleValueMask('Material', e.target.value, true)}
                  placeholder={'Desc. do material'}
                />
              </FormGroup>
              <FormGroup className={styles.formGroup}>
                <Form.Label className={styles.formLabel}>Cor Material</Form.Label>
                <Form.Control
                  type="text"
                  value={filterObj.CorMaterial || ''}
                  onChange={e => handleValueMask('CorMaterial', e.target.value, true)}
                  placeholder={'Cod. de cor do material'}
                />
              </FormGroup>
              <FormGroup className={styles.formGroup}>
                <Form.Label className={styles.formLabel}>Pedido</Form.Label>
                <Form.Control
                  type="text"
                  value={filterObj.Pedido || ''}
                  onChange={e => handleValueMask('Pedido', e.target.value, true)}
                  placeholder={'Número do Pedido'}
                />
              </FormGroup>
              <Button
                className={styles.formBtn}
                variant="primary"
                type="button"
                onClick={handleSearch}
              >
                Buscar
              </Button>
            </Form>
          </article>

          {/* Accordion Dados do Pedido */}
          <article className="p-2 mt-2">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Dados do pedido</Accordion.Header>
                <Accordion.Body>
                  <article className={styles.monitorInfo}>
                    <div className={styles.infoBlock}>
                      <div className={styles.infoBlockColumm}>
                        <span>Pedido:</span>
                        <span className={styles.fontBlue}>{activeObj.Pedido || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Material:</span>
                        <span className={styles.fontBlue}>{activeObj.Material || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Cód. Fornecedor:</span>
                        <span className={styles.fontBlue}>{activeObj.CodigoFornecedor || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Fornecedor:</span>
                        <span className={styles.fontBlue}>{activeObj.NomeCliFor || '-'}</span>
                      </div>
                    </div>
                    <div className={styles.infoBlock}>
                      <div className={styles.infoBlockColumm}>
                        <span>Nota Fiscal:</span>
                        <span className={styles.fontBlue}>{activeObj.NFEntrada || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Descrição Material:</span>
                        <span className={styles.fontBlue}>{activeObj.DescricaoMaterial || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Tipo:</span>
                        <span className={styles.fontBlue}>{activeObj.Tipo || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Requerido por:</span>
                        <span className={styles.fontBlue}>{activeObj.RequeridoPor || '-'}</span>
                      </div>
                    </div>
                    <div className={styles.infoBlock}>
                      <div className={styles.infoBlockColumm}>
                        <span>Série NF:</span>
                        <span className={styles.fontBlue}>{activeObj.SerieNF || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Cor Material:</span>
                        <span className={styles.fontBlue}>{activeObj.CorMaterial || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Qtde Recebida:</span>
                        <span className={styles.fontBlue}>{activeObj.QtdeEntrada || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Qtde Peças:</span>
                        <span className={styles.fontBlue}>{activeObj.QtdePecas || '-'}</span>
                      </div>
                    </div>
                    <div className={styles.infoBlock}>
                      <div className={styles.infoBlockColumm}>
                        <span>Data Entrada NF:</span>
                        <span className={styles.fontBlue}>{activeObj.recebimento || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Descrição Cor:</span>
                        <span className={styles.fontBlue}>{activeObj.DescricaoCor || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Data Revisão:</span>
                        <span className={styles.fontBlue}>{activeObj.DataRevisao || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Marca:</span>
                        <span className={styles.fontBlue}>{activeObj.Marca || '-'}</span>
                      </div>
                    </div>
                    <div className={styles.infoBlock}>
                      <div className={styles.infoBlockColumm}>
                        <span>Prioridade:</span>
                        <span className={styles.fontBlue}>{activeObj.Prioridade || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Responsável Revisão:</span>
                        <span className={styles.fontBlue}>{activeObj.ResponsavelRevisao || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Grupo:</span>
                        <span className={styles.fontBlue}>{activeObj.Grupo || '-'}</span>
                      </div>
                      <div className={styles.infoBlockColumm}>
                        <span>Tipo Compra:</span>
                        <span className={styles.fontBlue}>{activeObj.TipoCompra || '-'}</span>
                      </div>
                    </div>
                  </article>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </article>

          {/* Table Monitor */}
          <article className={styles.articleGray}>
            {loading ? (
              <Carregando />
            ) : (
              <DataTable
                columns={columns}
                data={mainData}
                dense
                highlightOnHover
                pointerOnHover
                onRowClicked={(row) => setActiveObj(row)}
                customStyles={customStyles}
                pagination={true}
              />
            )}
          </article>

          {/* Modal Envio Amostra Aprovação Estilo */}
          <Modal
            show={showModalEnvio}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
            centered
            dialogClassName={styles.modalWidth}
          >
            <Modal.Header closeButton>
              <Modal.Title>Envio de Amostra para Aprovação Estilo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* Informações sobre o material */}
              <article className="p-2 mt-2">
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Dados do pedido</Accordion.Header>
                    <Accordion.Body>
                      <article className={styles.monitorInfo}>
                        <div className={styles.infoBlock}>
                          <div className={styles.infoBlockColumm}>
                            <span>Pedido:</span>
                            <span className={styles.fontBlue}>{activeObj.Pedido}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Material:</span>
                            <span className={styles.fontBlue}>{activeObj.Material}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Cód. Fornecedor:</span>
                            <span className={styles.fontBlue}>{activeObj.CodigoFornecedor}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Fornecedor:</span>
                            <span className={styles.fontBlue}>{activeObj.NomeCliFor}</span>
                          </div>
                        </div>
                        <div className={styles.infoBlock}>
                          <div className={styles.infoBlockColumm}>
                            <span>Nota Fiscal:</span>
                            <span className={styles.fontBlue}>{activeObj.NFEntrada}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Descrição Material:</span>
                            <span className={styles.fontBlue}>{activeObj.DescricaoMaterial}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Tipo:</span>
                            <span className={styles.fontBlue}>{activeObj.Tipo}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Requerido por:</span>
                            <span className={styles.fontBlue}>{activeObj.RequeridoPor}</span>
                          </div>
                        </div>
                        <div className={styles.infoBlock}>
                          <div className={styles.infoBlockColumm}>
                            <span>Série NF:</span>
                            <span className={styles.fontBlue}>{activeObj.SerieNF}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Cor Material:</span>
                            <span className={styles.fontBlue}>{activeObj.CorMaterial}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Qtde Recebida:</span>
                            <span className={styles.fontBlue}>{activeObj.QtdeEntrada}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Qtde Peças:</span>
                            <span className={styles.fontBlue}>{activeObj.x} - </span>
                          </div>
                        </div>
                        <div className={styles.infoBlock}>
                          <div className={styles.infoBlockColumm}>
                            <span>Data Entrada NF:</span>
                            <span className={styles.fontBlue}>{toUTCDDMMYYYY(activeObj.recebimento)}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Descrição Cor:</span>
                            <span className={styles.fontBlue}>{activeObj.DescricaoCor}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Data Revisão:</span>
                            <span className={styles.fontBlue}>{activeObj.DataRevisao}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Marca:</span>
                            <span className={styles.fontBlue}>{activeObj.Marca}</span>
                          </div>
                        </div>
                        <div className={styles.infoBlock}>
                          <div className={styles.infoBlockColumm}>
                            <span>Prioridade:</span>
                            <span className={styles.fontBlue}>{activeObj.Prioridade}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Responsável Revisão:</span>
                            <span className={styles.fontBlue}>{activeObj.ResponsavelRevisao}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Grupo:</span>
                            <span className={styles.fontBlue}>{activeObj.Grupo}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Tipo Compra:</span>
                            <span className={styles.fontBlue}>{activeObj.TipoCompra}</span>
                          </div>
                        </div>
                      </article>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </article>

              {/* Formulário de inserção */}
              <article>
                <Form className={styles.form}>
                  <FormGroup className={styles.formGroupModal} controlId={'ResponsavelAprovacao'}>
                    <Form.Label className={styles.formLabel}>Responsável Aprovação/Ponto Focal:</Form.Label>
                    <Select
                      placeholder={'Selecionar'}
                      options={responsavelAprovacaoLista}
                      value={formObj.ResponsavelAprovacao || null}
                      onFocus={() => clearErrs('ResponsavelAprovacao')}
                      onChange={e => setFormObj({ ...formObj, ResponsavelAprovacao: e })}
                      isClearable={true}
                      escapeClearsValue={true}
                      styles={{
                        control: (provided) => (
                          formErrs.ResponsavelAprovacao ? { ...provided, borderColor: '#dc3545' } : { ...provided, borderColor: 'hsl(0, 0%, 80%)' }
                        )
                      }}
                    />
                    <div className={formErrs.ResponsavelAprovacao ? styles.showFeedback : styles.hidden}>{formErrs.ResponsavelAprovacao}</div>
                  </FormGroup>
                  <FormGroup className={styles.formGroupModal} controlId={'MotivoEnvio'}>
                    <Form.Label className={styles.formLabel}>Motivo do Envio:</Form.Label>
                    <Form.Control
                      value={activeObj.MotivoEnvio || null}
                      onClick={() => clearErrs('LacreEnvio')}
                      onFocus={() => clearErrs('MotivoEnvio')}
                      onChange={e => setFormObj({ ...formObj, MotivoEnvio: e })}
                      disabled={true}
                      isClearable={true}
                      escapeClearsValue={true}
                      styles={{
                        control: (provided) => (
                          formErrs.MotivoEnvio ? { ...provided, borderColor: '#dc3545' } : { ...provided, borderColor: 'hsl(0, 0%, 80%)' }
                        )
                      }}
                    />
                    <div className={formErrs.MotivoEnvio ? styles.showFeedback : styles.hidden}>{formErrs.MotivoEnvio}</div>
                  </FormGroup>
                </Form>
                <Form className={styles.form}>
                  <FormGroup className={styles.formGroupModal} controlId={'DataEnvioAprovacao'}>
                    <Form.Label className={styles.formLabel}>Data Envio Aprovação:</Form.Label>
                    <Form.Control
                      type="date"
                      style={{ "cursor": "text" }}
                      value={formObj.DataEnvioAprovacao || ''}
                      onClick={() => clearErrs('DataEnvioAprovacao')}
                      onChange={e => setFormObj({ ...formObj, DataEnvioAprovacao: e.target.value })}
                      min={today}
                      max={'3000-01-01'}
                      isInvalid={formErrs.DataEnvioAprovacao}
                    />
                    <Form.Control.Feedback type='invalid'>{formErrs.DataEnvioAprovacao}</Form.Control.Feedback>
                  </FormGroup>
                  <FormGroup className={styles.formGroupModal} controlId={'LacreEnvio'}>
                    <Form.Label className={styles.formLabel}>Número do Lacre:</Form.Label>
                    <Form.Control
                      value={formObj.LacreEnvio || ''}
                      onClick={() => clearErrs('LacreEnvio')}
                      onChange={e => handleValueMask('LacreEnvio', e.target.value)}
                      isInvalid={formErrs.LacreEnvio}
                    />
                    <Form.Control.Feedback type='invalid'>{formErrs.LacreEnvio}</Form.Control.Feedback>
                  </FormGroup>
                </Form>
              </article>
            </Modal.Body>
            <Modal.Footer className={styles.modalFooter}>
              <Button
                className={styles.iconCursor}
                variant="outline-danger"
                onClick={handleCloseModal}
              >
                Cancelar
              </Button>
              <Button
                className={styles.iconCursor}
                variant="primary"
                onClick={handleEnvioProcessing}
              >
                Enviar Amostra
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal Confirmar Amostr Enviada Aprovação Estilo */}
          <Modal
            show={showModalRecebimento}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
            centered
            dialogClassName={styles.modalWidth}
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirmar Recebimento / Retorno de Amostra Enviada para Aprovação Estilo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* Informações sobre o material */}
              <article className="p-2 mt-2">
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Dados do pedido</Accordion.Header>
                    <Accordion.Body>
                      <article className={styles.monitorInfo}>
                        <div className={styles.infoBlock}>
                          <div className={styles.infoBlockColumm}>
                            <span>Pedido:</span>
                            <span className={styles.fontBlue}>{activeObj.Pedido}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Material:</span>
                            <span className={styles.fontBlue}>{activeObj.Material}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Cód. Fornecedor:</span>
                            <span className={styles.fontBlue}>{activeObj.CodigoFornecedor}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Fornecedor:</span>
                            <span className={styles.fontBlue}>{activeObj.NomeCliFor}</span>
                          </div>
                        </div>
                        <div className={styles.infoBlock}>
                          <div className={styles.infoBlockColumm}>
                            <span>Nota Fiscal:</span>
                            <span className={styles.fontBlue}>{activeObj.NFEntrada}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Descrição Material:</span>
                            <span className={styles.fontBlue}>{activeObj.DescricaoMaterial}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Tipo:</span>
                            <span className={styles.fontBlue}>{activeObj.Tipo}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Requerido por:</span>
                            <span className={styles.fontBlue}>{activeObj.RequeridoPor}</span>
                          </div>
                        </div>
                        <div className={styles.infoBlock}>
                          <div className={styles.infoBlockColumm}>
                            <span>Série NF:</span>
                            <span className={styles.fontBlue}>{activeObj.SerieNF}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Cor Material:</span>
                            <span className={styles.fontBlue}>{activeObj.CorMaterial}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Qtde Recebida:</span>
                            <span className={styles.fontBlue}>{activeObj.QtdeEntrada}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Qtde Peças:</span>
                            <span className={styles.fontBlue}>{activeObj.QtdePecas || '-'}</span>
                          </div>
                        </div>
                        <div className={styles.infoBlock}>
                          <div className={styles.infoBlockColumm}>
                            <span>Data Entrada NF:</span>
                            <span className={styles.fontBlue}>{toUTCDDMMYYYY(activeObj.recebimento)}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Descrição Cor:</span>
                            <span className={styles.fontBlue}>{activeObj.DescricaoCor}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Data Revisão:</span>
                            <span className={styles.fontBlue}>{activeObj.DataRevisao}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Marca:</span>
                            <span className={styles.fontBlue}>{activeObj.Marca}</span>
                          </div>
                        </div>
                        <div className={styles.infoBlock}>
                          <div className={styles.infoBlockColumm}>
                            <span>Prioridade:</span>
                            <span className={styles.fontBlue}>{activeObj.Prioridade}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Responsável Revisão:</span>
                            <span className={styles.fontBlue}>{activeObj.ResponsavelRevisao}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Grupo:</span>
                            <span className={styles.fontBlue}>{activeObj.Grupo}</span>
                          </div>
                          <div className={styles.infoBlockColumm}>
                            <span>Tipo Compra:</span>
                            <span className={styles.fontBlue}>{activeObj.TipoCompra}</span>
                          </div>
                        </div>
                      </article>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </article>

              {/* Formulário de inserção */}
              <article>
                <Form className={styles.form}>
                  <FormGroup className={styles.formGroupModal}>
                    <Form.Label className={styles.formLabel}>Responsável Aprovação/Ponto Focal:</Form.Label>
                    <span className={styles.fontBlueModal}>{activeObj.ResponsavelAprovacao}</span>
                  </FormGroup>
                  <FormGroup className={styles.formGroupModal}>
                    <Form.Label className={styles.formLabel}>Data Recebimento Amostra:</Form.Label>
                    <Form.Control
                      type="date"
                      style={{ "cursor": "text" }}
                      value={formObj.DataRecebimentoAmostra || ''}
                      onClick={() => clearErrs('DataRecebimentoAmostra')}
                      onChange={e => setFormObj({ ...formObj, DataRecebimentoAmostra: e.target.value })}
                      min={today}
                      max={'3000-01-01'}
                      isInvalid={formErrs.DataRecebimentoAmostra}
                    />
                    <Form.Control.Feedback type='invalid'>{formErrs.DataRecebimentoAmostra}</Form.Control.Feedback>
                  </FormGroup>
                  {/* <FormGroup className={styles.formGroupModal}>
                    <Form.Label className={styles.formLabel}>Responsável Recebimento:</Form.Label>
                    <Select
                      placeholder={'Selecionar'}
                      options={optionsObj.ResponsavelRecebimentoLista}
                      value={formObj.ResponsavelRecebimento || null}
                      onFocus={() => clearErrs('ResponsavelRecebimento')}
                      onChange={e => setFormObj({...formObj, ResponsavelRecebimento: e})}
                      isClearable={true}
                      escapeClearsValue={true}
                      styles={{
                        control: (provided) => (
                          formErrs.ResponsavelRecebimento ? {...provided, borderColor: '#dc3545'} : {...provided, borderColor: 'hsl(0, 0%, 80%)'}
                        )
                      }}
                    />
                    <div className={formErrs.ResponsavelRecebimento ? styles.showFeedback : styles.hidden}>{formErrs.ResponsavelRecebimento}</div>
                  </FormGroup> */}
                </Form>
                <Form className={styles.form}>
                  <FormGroup className={styles.formGroupModal}>
                    <Form.Label className={styles.formLabel}>Confirmado Envio de Amostra?</Form.Label>
                    <span className={styles.fontBlueModal}>{activeObj.ConfirmaEnvioAmostra}</span>
                  </FormGroup>
                  <FormGroup className={styles.formGroupModal}>
                    <Form.Label className={styles.formLabel}>Confirmado Retorno de Amostra?</Form.Label>
                    <span className={styles.fontBlueModal}>{activeObj.ConfirmaRetornoAmostra}</span>
                  </FormGroup>
                  <FormGroup className={styles.formGroupModal}>
                    <Form.Label className={styles.formLabel}>Lacre Retorno de Amostra:</Form.Label>
                    <span className={styles.fontBlueModal}>{activeObj.LacreRetornoAmostra}</span>
                  </FormGroup>
                </Form>
              </article>
              <CustomPagination></CustomPagination>

            </Modal.Body>
            <Modal.Footer className={styles.modalFooter}>
              <Button
                className={styles.iconCursor}
                variant="outline-danger"
                onClick={handleCloseModal}
              >
                Cancelar
              </Button>
              <Button
                className={styles.iconCursor}
                variant="primary"
                onClick={handleRecebimentoProcessing}
              >
                Confirmar
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
      />
    </div>
  );
}

export default Adm;
